<template>
       
    <naj-modal ref="executionRequestsModal"
               :title="local.caseFile.cards.judgement.execution.requestList"
               :width="700"
               :persistent="true"
               :footer="true"
               :show-footer-close-button="false"
               transition="scroll-x-transition"
               content-class="dialog-content-class"
               @onClose="closeModal">

        <v-row>
            <v-col>
                <naj-alert type="alert">
                    <template slot="content">
                        <span class="caution-content"> {{ local.caseFile.cards.judgement.execution.requestDetailsOnExecutionTab }} 
                            <a style="display:inline-block" :href="executionUrl"> {{local.caseFile.cards.judgement.execution.execution}}</a>
                        </span>
                    </template>
                </naj-alert>
            </v-col>
        </v-row>
        <div class="case-info-text">
            <v-row class="mt-7">
                <v-col cols="12">
                    <naj-item-table :data-items="requests"
                                    :headers="headers"
                                    :items-per-page="(requests||[]).length"
                                    :server-items-length="(requests||[]).length"
                                    :loading="loading">
                        <template slot="requestCode"
                                  slot-scope="{item}">
                            <div class="info-item-details-title">
                                {{ local.caseFile.cards.judgement.execution.requestNo }}
                            </div>
                            <div class="info-item-details-value mt-3">
                                {{ item.requestCode }}
                            </div>
                        </template>
                        <template slot="partyName"
                                  slot-scope="{item}">
                            <div class="info-item-details-title">
                                {{ local.caseFile.cards.judgement.execution.partyName }}
                            </div>
                            <div class="info-item-details-value">
                                {{ item.requesterName}}
                            </div>
                        </template>
                        <template slot="createdDate"
                                  slot-scope="{item}">
                            <div class="info-item-details-title">
                                {{ local.caseFile.cards.judgement.execution.requestDate }}
                            </div>
                            <div class="info-item-details-value">
                                {{ item.createdDate}}
                            </div>
                        </template>

                        <template slot="dueAmount"
                                  slot-scope="{item}">
                            <div class="info-item-details-title">
                                {{ local.caseFile.cards.judgement.execution.dueAmount }}
                            </div>
                            <div class="info-item-details-value">
                                {{ item.dueAmount}}
                            </div>
                        </template>


                    </naj-item-table>
                </v-col>
            </v-row>
        </div>
        <template slot="actions"
                  slot-scope="{ closeNajModal }">
            <div>
                <naj-button outlined
                            @click="closeModal">
                    {{ local.caseFile.cards.judgement.execution.close }}
                </naj-button>
            </div>

        </template>
    </naj-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');
import { casePartyRoleEnum } from '@/helpers/enum.js';
import { toHijriDate } from '@/helpers/utils';


export default {
  components: {},
  props: {
    modalVisibility: {
      default: false,
      type: Boolean,
      required: false,
    },
    judgement: {
      required: true,
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      loading: false,
      viewMode: false,
      isChecking: false,
      isPega: true,
      partyRoleId: null,
      casePartyRoleEnum,
      closeStateModal: true,
      requesters: [],
      requesterId: '',
      respondentId: '',
      requesterRoleInCase: null,
      caseObjectKey: null,
      formModel: {},
      requests: [],
      toHijriDate,
      headers: [
            {
                value: 'requestCode',
                text: this.local.caseFile.cards.judgement.execution.requestNo,
                class: 'caseCode-header',
            },
            {
                value: 'requesterName',
                text: this.local.caseFile.cards.judgement.execution.partyName,
            },
            {
                value: 'createdDate',
                text: this.local.caseFile.cards.judgement.execution.requestDate,
                formatter: (val) => { return this.toHijriDate(val) || '---'; },
            },

            {
                value: 'dueAmount',
                text: this.local.caseFile.cards.judgement.execution.dueAmount,
                formatter: (val) => { return `${val} ${this.local.judicialFees.sar}`; }

            }
        ],
    };
  },
  computed: {
      executionUrl(){

          return window.location.origin + '/applications/iexecution';
      }
  },
        watch: {
         modalVisibility(newVal) {
          if (newVal) {
              this.$refs.executionRequestsModal.show();
              this.loadRequesters();

          } else {
          this.$refs.executionRequestsModal.close();
          }
        },
  },
  methods: {
    ...mapCasesActions([
        'getExecutionRequests',
        'getUserCasePartyRoleInCase',
        'getCaseRequestApplicants',

    ],
    toHijriDate),
   
      loadRequesters() {
          this.caseObjectKey = this.$route.params.caseObjectKey;
          this.loading = true;
          const params = {
              isPega: this.isPega,
              objectKey: this.caseObjectKey,
          };
          Promise.all([
              this.getCaseRequestApplicants(params),
              this.getUserCasePartyRoleInCase(params),
          ])
              .then((res) => {
                  this.requesters = res[0].data.requestApplicants;
                  this.formModel.requesterId = this.requesters[0].casePartyId
                  this.requesterId = this.formModel.requesterId;
                  this.requesterRoleInCase = res[1].data;
                  this.loadExecutionRequests();
              })
              .catch(err => this.toaster.error(err.message))
              .finally(() => (this.loading = false));
      },
      loadExecutionRequests() {
          var payload = {
              judgementId: this.judgement.id,
              casePartyId: this.formModel.requesterId
          };
          this.getExecutionRequests(payload)
              .then(({ data }) => {
                  this.requests = data;
              });
      },
    closeModal() {
        this.$emit('modalClose');
      }
  },
};
</script>

<style lang="scss" scoped>

    ::v-deep .naj-box-contnet {
        padding-top: unset !important;
    }

    ::v-deep .naj-box .naj-box-contnet {
        padding-top: unset !important;
    }

    .v-input .v-label {
        font-weight: bold;
    }

    ::v-deep .v-input {
        &.v-text-field--outlined {
            .v-label {
                font-weight: bold !important;
            }
        }
    }

    ::v-deep .v-input.v-text-field--outlined .v-label {
        font-weight: bold;
    }

    ::v-deep .v-input.v-text-field--outlined .v-input__slot {
        min-height: 25px;
    }

    ::v-deep .v-icon.v-icon {
        font-size: 15px !important;
    }

    .execution-note {
        font-size: 16px;
        color: var(--app-info-color);
    }


    .caution-content {
        font-weight: bold;
    }

    ::v-deep .v-alert__wrapper {
        padding: unset !important;
    }

    ::v-deep .naj-box-contnet {
        padding-top: unset !important;
    }

    ::v-deep .naj-box .naj-box-contnet {
        padding-top: unset !important;
    }
</style>